'use client';
import { createLogger } from '@svs/nova-core/log';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { getValidatedQueryParameters } from '../../../../lib/entry.browser.js';
const logger = createLogger('poolbetting.no-opened-draw-redirect');
/**
 * Redirects the user to a valid url in case if the a draw is not opened or out of date.
 *
 * @param root0 Component props
 * @param root0.openedDraws Array of opened draws to check if the current draw is open.
 * @returns Redirect component
 */
export function RedirectNoOpenedDraw({ openedDraws }) {
    const searchParams = useSearchParams();
    const pathname = usePathname();
    const router = useRouter();
    const draw = searchParams.get('draw');
    const validatedDrawNumber = getValidatedQueryParameters('draw')(searchParams).draw;
    useEffect(() => {
        if ((draw !== null && validatedDrawNumber === undefined) ||
            (validatedDrawNumber !== undefined && !openedDraws.includes(validatedDrawNumber))) {
            const qs = new URLSearchParams(searchParams.toString());
            logger.info(`Current draw is not opened, redirecting to url without draw parameter: draw: ${draw}`);
            qs.delete('draw');
            const newUrl = qs.toString() ? `${pathname}?${qs.toString()}` : pathname;
            router.replace(newUrl);
        }
    }, [searchParams, pathname, router, openedDraws, draw, validatedDrawNumber]);
    return undefined;
}
//# sourceMappingURL=RedirectNoOpenedDraw.js.map